import { JSX } from "react";

export default function ContactInfo(): JSX.Element {
    return (
        <div className="col-lg-6">
            <h2 className="mb-4 text-primary">Skontaktuj się z nami</h2>
            <ul className="list-unstyled contact-info fs-5">
                <li><i className="bi bi-geo-alt-fill"></i>Szczuczyńska 57, 76-200 Słupsk</li>
                <li><i className="bi bi-telephone-fill"></i> +48 506 612 466</li>
                <li><i className="bi bi-envelope-fill"></i><a
                    href="mailto:msas.garage@gmail.com">msas.garage@gmail.com</a></li>
                <li><i className="bi bi-clock-fill"></i> Pon–Pt: 7:30 – 17:00</li>
            </ul>
        </div>
    )
};